export enum ModalType {
  None = 0,
  AlreadyExistsDocumentNumber,
  DocumentTemplates,
  ShippingLabel,
  ChangePaymentStatus,
  ChangeDeliveryStatus,
  ChangeOtherStatuses,
  GenerateDocumentNumberConfirmationModal,
  SplitOrders,
  MergeOrders,
  SynchOrdersComplete,
  EmailSend,
}
